import logoSrc from '@/assets/Logo.svg'

interface LogoProps {
  /** Tailwind sizing/utility classes applied to the <img>. */
  className?: string
  /** Accessible label. */
  alt?: string
}

/**
 * Osprey wordmark.
 *
 * The source SVG is a single near-black artwork (`#28282A`). To stay legible on
 * dark backgrounds we flip it to near-white via a filter when the `dark` class
 * is present on <html> — `brightness-0` collapses the art to black, then
 * `invert` flips it to white. This keeps ONE asset working on both themes
 * without a separate white logo file.
 */
export const Logo = ({ className = 'h-[30px] w-auto', alt = 'Osprey' }: LogoProps) => (
  <img
    src={logoSrc}
    alt={alt}
    className={`select-none dark:brightness-0 dark:invert ${className}`}
    draggable={false}
  />
)

export default Logo
